interface FileAttachmentsListProps<Attachment> {
  attachments: Attachment[];
  renderAttachment: (attachment: Attachment) => JSX.Element;
}

export default function FileAttachments<Attachment>({
  attachments,
  renderAttachment,
}: FileAttachmentsListProps<Attachment>) {
  return (
    <div className="flex w-full mt-auto flex-col gap-2 overflow-x-auto scrollbar-thin lg:flex-row pt-2.5 pb-1.5 -mb-1.5 px-1 -mx-1">
      {attachments.map((attachment) => {
        return renderAttachment(attachment);
      })}
    </div>
  );
}
